module.exports = global["angular"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?angular!./~/angular/index.js
// module id = 520
// module chunks = 6